import { render, staticRenderFns } from "./SystemConfigManagePage.vue?vue&type=template&id=484be88e"
import script from "./SystemConfigManagePage.vue?vue&type=script&lang=js"
export * from "./SystemConfigManagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports